import Vue from "vue";
import Router from "vue-router";
import store from "./store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/about",
      name: "about",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue")
    },
    {
      path: "/home",
      name: "Home",
      component: () => import(/* webpackChunkName: "Home" */ "@/views/Home.vue")
    },
    {
      path: "/mentors/search",
      name: "Hub",
      component: () => import(/* webpackChunkName: "Hub" */ "@/views/Hub.vue")
    },
    {
      path: "/signup",
      name: "Signup",
      component: () =>
        import(/* webpackChunkName: "Signup" */ "@/views/Signup.vue")
    },
    {
      path: "/login",
      name: "Login",
      component: () =>
        import(/* webpackChunkName: "Login" */ "@/views/Login.vue")
    },
    {
      path: "/dashboard",
      name: "Dashboard",
      component: () =>
        import(/* webpackChunkName: "Dashboard" */ "@/views/Dashboard.vue")
    },
    {
      path: "/edit-profile",
      name: "EditProfile",
      component: () =>
        import(/* webpackChunkName: "EditProfile" */ "@/views/EditProfile.vue")
    },
    {
      path: "/admin",
      name: "Admin",
      component: () =>
        import(/* webpackChunkName: "Admin" */ "@/views/Admin.vue")
    },
    {
      path: "/admin/users",
      name: "Users",
      component: () =>
        import(/* webpackChunkName: "Users" */ "@/views/Users.vue")
    },
    {
      path: "/admin/hubs",
      name: "Hubs",
      component: () => import(/* webpackChunkName: "Hubs" */ "@/views/Hubs.vue")
    },
    {
      path: "/request-password-reset",
      name: "RequestPasswordReset",
      component: () =>
        import(
          /* webpackChunkName: "RequestPasswordReset" */ "@/views/RequestPasswordReset.vue"
        )
    },
    {
      path: "/password-reset/",
      name: "PasswordReset",
      component: () =>
        import(
          /* webpackChunkName: "PasswordReset" */ "@/views/PasswordReset.vue"
        )
    },
    {
      path: "/user/:id",
      name: "User",
      component: () => import(/* webpackChunkName: "User" */ "@/views/User.vue")
    },
    {
      path: "/hub",
      name: "Hub",
      component: () => import(/* webpackChunkName: "Hub" */ "@/views/Hub.vue")
    },
    {
      path: "/hub/:hubId",
      name: "Hub",
      component: () => import(/* webpackChunkName: "Hub" */ "@/views/Hub.vue")
    },
    {
      path: "/message/:id",
      name: "Message",
      component: () =>
        import(/* webpackChunkName: "Hub" */ "@/views/Message.vue")
    },
    {
      path: "/guides",
      name: "Guides",
      component: () =>
        import(/* webpackChunkName: "Guides" */ "@/views/Guides.vue")
    },
    {
      path: "/become-a-guide",
      name: "BecomeAGuide",
      component: () =>
        import(
          /* webpackChunkName: "BecomeAGuide" */ "@/views/BecomeAGuide.vue"
        )
    },
    {
      path: "/register",
      name: "Register",
      component: () =>
        import(/* webpackChunkName: "Register" */ "@/views/Register.vue")
    },
    { path: "*", redirect: "/home" }
  ]
});

router.beforeEach((to, from, next) => {
  const protectedRoutes = ["/dashboard", "/edit-profile", "/admin"];
  if (protectedRoutes.includes(to.fullPath)) {
    if (!store.state.token) {
      next("/login");
    }
  }
  next();
});
export default router;
